import mixpanel, { Mixpanel } from 'mixpanel-browser';
import React, { Context, createContext } from 'react';
import { AppRootContext } from './AppRootContext';

export const MixpanelContext: Context<Mixpanel> = createContext(null);

type MixpanelProviderProps = {
  children: React.ReactNode;
};

export function MixpanelProvider({ children }: MixpanelProviderProps) {
  return (
    <MixpanelContext.Provider value={mixpanel}>
      {children}
    </MixpanelContext.Provider>
  );
}

export function initMixpanelStepOne() {
  if (!window.materio?.mixpanel?.enabled) {
    return; // No-Op; MixPanel is disabled
  }

  mixpanel.init(window.materio.mixpanel.projectToken, {
    track_pageview: 'url-with-path',
    persistence: 'localStorage',
  });

  // Backwards-compability; older code may call window.mixpanel directly
  window.mixpanel = mixpanel;
}

export function initMixpanelStepTwo(ctx: AppRootContext) {
  if (!window.materio?.mixpanel?.enabled) {
    return; // No-Op; MixPanel is disabled
  }

  const { actualUser, org } = ctx;

  if (actualUser) {
    mixpanel.identify(actualUser.id);
    mixpanel.people.set({
      orgName: org?.name,
      name: actualUser.fullName,
      email: actualUser.email,
      $email: actualUser.email,
      type: actualUser.userType,
      phase: org?.phase,
    });

    mixpanel.register({
      userType: actualUser.userType,
    });
  }

  if (org) {
    mixpanel.set_group('orgId', org.id);
  }
}
